import React from 'react'
import { useLocation } from 'react-router-dom'
import FooterLogo from '../../assets/images/logo_02.png'
import '../../assets/css/headerFooter.css'

const Footer = () => {
    const currentYear = new Date().getFullYear().toString()
    const location = useLocation()
    const cdp = (path) => {
        if (path.includes('recruit')) {
            return 'http://www.metlife.co.jp/recruit/consultant/privacy/'
        } else {
            return 'http://www.metlife.co.jp/about/governance/privacy-policy/'
        }
    }
    return (
        <div id="footerFrame">
        <div id="footerLink">
            <div id="footerLogo" className="footerLogo"><a href="http://www.metlife.co.jp/" ><img src={FooterLogo} alt="MetLife　生命保険のメットライフ生命"/></a></div>
                <ul className="clearfix">
                <li><a href="http://www.metlife.co.jp/about/" >企業情報</a></li>
                <li><a href={cdp(location.pathname)} >個人情報の取扱いについて</a></li>
                <li><a href="http://www.metlife.co.jp/terms_of_use.html" >ご利用の条件</a></li>
                </ul>
                <div className="copyrightBox clearfix">
                <p>©{currentYear} MetLife, Inc. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}

export default Footer
